// src/config.ts
const env = import.meta.env.VITE_ENV
export const APP_ENV = env

const apiUrl = import.meta.env.VITE_ENV === 'production' ? import.meta.env.VITE_API_URL : 'http://localhost:3001/api';
if (!apiUrl) throw new Error("Missing VITE_API_URL");
export const API_URL = apiUrl;

const webSocketUrl = import.meta.env.VITE_ENV === 'production' ? import.meta.env.VITE_WS_URL : 'ws://localhost:8080';
if (!webSocketUrl) throw new Error("Missing VITE_WS_URL");
export const WS_URL = webSocketUrl 

const statsApiUrl = import.meta.env.VITE_ENV === 'production' ? import.meta.env.VITE_STATS_API_URL : 'http://localhost:8000/stats';
if (!statsApiUrl) throw new Error("Missing VITE_STATS_API_URL");
export const STATS_API_URL = statsApiUrl;

const appVersionNumber = import.meta.env.VITE_APP_VERSION ?? '1.0.0';
if (!appVersionNumber) throw new Error("Missing VITE_APP_VERSION");
export const APP_VERSION = appVersionNumber;

const appVersionDate = import.meta.env.VITE_APP_VERSION_DATE ?? '2026-01-29';
if (!appVersionDate) throw new Error("Missing VITE_APP_VERSION_DATE");
export const APP_VERSION_DATE = appVersionDate;

const NumberDecimalPlaces = import.meta.env.VITE_NUMBER_DECIMAL_PLACES ? parseInt(import.meta.env.VITE_NUMBER_DECIMAL_PLACES) : 8;
if (isNaN(NumberDecimalPlaces)) throw new Error("Invalid VITE_NUMBER_DECIMAL_PLACES");
export const NUMBER_DECIMAL_PLACES = NumberDecimalPlaces;

export const USE_MOCK_API = import.meta.env.VITE_USE_MOCK_API === 'true';

export const ACCOUNT_REQUEST_EMAIL =
	import.meta.env.VITE_ACCOUNT_REQUEST_EMAIL ?? 'example@gmail.com';